import React from "react";

function Header() {
  return (
    <div className="header">
      <h1>Meme Generator</h1>
    </div>
  );
}

export default Header;
